import React from 'react';
import PropTypes from 'prop-types';
import joinClassNames from "../../../common/JoinClassNames";
import CommonAppSetup from "../../../common/common-app-setup/CommonAppSetup";
import Components from "../../../common/Components";

const propTypes = {
	// max legal # of characters, note that this does not do real "form validation" on posting
	// and is only pig lipstick
	maxLengthCounter: PropTypes.number,

	// render your own counter message:
	// ({length, maxLengthCounter, value}) => <div><span>whatever you want!</span><span>{`${length}/${maxLengthCounter} : ${value[0].toUpperCase()}`}</span></div>;
	onMessageRender: PropTypes.func,

	// the value of this field: should be a string/number that can be put in an input
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
};

const defaultProps = {
	maxLengthCounter: undefined,
	onMessageRender: undefined,
	value: '',
};

const CharacterCounter = ({maxLengthCounter, onMessageRender, value}) => {
	const length = `${(value || '')}`.length;
	return (
		<div
			className={joinClassNames(
				"character-counter",
				length > maxLengthCounter ? "character-counter--limit" : undefined,
				length > maxLengthCounter ? CommonAppSetup.getClassName(Components.CHARACTER_COUNTER, 'error') : undefined,
				CommonAppSetup.getClassName(Components.CHARACTER_COUNTER, 'wrapper'),
			)}
		>
			{onMessageRender ? onMessageRender({length, maxLengthCounter, value}) : <>{length}/{maxLengthCounter}</>}
		</div>
	);
};

CharacterCounter.propTypes = propTypes;
CharacterCounter.defaultProps = defaultProps;

export default CharacterCounter;
